import React from 'react'

import { Row, Col, Collapse } from 'antd';
import DetailItem from '../../../CSIComponents/DetailItem';
const { Panel } = Collapse;

interface DetailType {
    type: string | null, 
    charge: number | null, 
    currency: string | null, 
    chargeunit: string | null, 
    chargefrequency: string | null
}
interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
    disableTabPanes?: void | any,
    detail?: any,
    cancelAndSave?: void | any,
    tableCurrentData?: any,
    scheduleAndChargeData?: void | any,
    detailData?: void | any,

}
const ScheduleAndChargeDetail = (props: propsTypes) => {
    const detailData = [
        { label: 'Start Date', value: props?.detailData?.startdate, span: 6 },
        { label: 'End Date', value: props?.detailData?.enddate, span: 6 },
        { span: 5 }
    ]
    const getDefaultOpenKeys = (length: number) => Array.from({ length }).map((v, k) => k);
    return (
        <>
            <Row gutter={24}>
                {detailData.map((item, i) => {
                    return (
                        <>
                            {
                                item.label ? <Col span={item.span} key={i} className="col-margin">
                                    <DetailItem value={item.value} label={item.label} />
                                </Col> : <Col span={item.span} key={i}></Col>
                            }
                        </>

                    )
                })}
            </Row>
            <Row>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '75%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column-reverse', marginRight: 5, fontWeight: 'bold', }}>
                        <div style={{ height: 35 }}>Close</div>
                        <div style={{ height: 35 }}>Open</div>
                    </div>
                    {props?.detailData?.operationtime.map((item: {dayoftheweek: string | null, starttime: string | null, endtime: string | null}, index: number) => {
                        return (
                            <div style={{ flex: 1, 'userSelect': 'none' }}>
                                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>{item.dayoftheweek}</div>
                                <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                    <div style={{ height: 40, lineHeight: '40px', width: '70%', margin: 'auto', cursor: 'pointer' }}><span className="blue-font">{item.starttime}</span></div>
                                </div>
                                <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', borderTop: '0', padding: '20 0' }}>
                                    <div style={{ height: 40, lineHeight: '40px', width: '70%', margin: 'auto', cursor: 'pointer' }}><span className="blue-font">{item.endtime}</span></div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Row>
            <Row gutter={24}>
                <div style={{ width: '75%', marginTop: '30px' }}>
                    <Collapse defaultActiveKey={getDefaultOpenKeys(props?.detailData?.charge?.length)} ghost>
                        {props?.detailData?.charge?.map((item: DetailType, index: number) => {
                            return (
                                <React.Fragment key={index}>
                                    {<Panel style={{ border: '1px solid #e5e5e5', marginBottom: '20px', borderRadius: '4px', boxShadow: '0 2px 4px #ccc' }} header={`Charge ${index + 1}`} key={index}>
                                        <Row gutter={24}>
                                            <Col span={8}>
                                                <DetailItem value={item.type} label='Charge Type' span={6} />
                                            </Col>
                                            {
                                                item.type === "Amount" ? <>
                                                    <Col span={8}>
                                                        <DetailItem value={item.charge} label='Charge(Amount)' span={6} />
                                                    </Col>
                                                    <Col span={8}>
                                                        <DetailItem value={item.currency} label='Currency' span={6} />
                                                    </Col>
                                                </> : <>
                                                    <Col span={8}>
                                                        <DetailItem value={item.charge} label='Charge(Percent)' span={6} />
                                                    </Col>
                                                </>
                                            }

                                        </Row>
                                        <Row gutter={24}>
                                            <Col span={8}>
                                                <DetailItem value={item.chargeunit} label='Charge Unit' span={6} />
                                            </Col>
                                            <Col span={8}>
                                                <DetailItem value={item.chargefrequency} label='Charge Frequency' span={6} />
                                            </Col>
                                        </Row>
                                    </Panel>}
                                </React.Fragment>
                            )
                        })}
                    </Collapse>
                </div>
            </Row >

        </>
    )
}

export default ScheduleAndChargeDetail;